let idleCallback = null; // Store the callback function
let isUserIdle = false;  // Tracks if the user is idle
let idleTimer = null;    // Timer to track idle state
let timeoutDuration = 10000; // Default idle timeout

// Function to reset the idle timer
const resetTimer = () => {
  clearTimeout(idleTimer);
  isUserIdle = false; // User is active

  idleTimer = setTimeout(() => {
    isUserIdle = true; // User is idle
    if (idleCallback) idleCallback(true); // Trigger idle callback if set
  }, timeoutDuration);
};

// Sets the callback to be triggered when the user becomes idle
export const setIdleCallback = (callback) => {
  if (typeof callback === 'function') {
    idleCallback = callback;
  }
};

// Starts idle detection with a given timeout
export const startIdleDetection = (timeout = 3600000) => {
  timeoutDuration = timeout; // Update the timeout duration
  resetTimer(); // Initialize the timer

  // Attach event listeners to reset the timer on user activity
  window.addEventListener('load', resetTimer);
  document.addEventListener('mousemove', resetTimer);
  document.addEventListener('keypress', resetTimer);
  window.addEventListener('click', resetTimer);
  window.addEventListener('scroll', resetTimer);
};

// Stops idle detection by clearing listeners and the timer
export const stopIdleDetection = () => {
  clearTimeout(idleTimer); // Clear the timer
  isUserIdle = false; // Reset idle status

  // Remove event listeners to stop idle detection
  window.removeEventListener('load', resetTimer);
  document.removeEventListener('mousemove', resetTimer);
  document.removeEventListener('keypress', resetTimer);
  window.removeEventListener('click', resetTimer);
  window.removeEventListener('scroll', resetTimer);
};

// Returns the current idle status
export const getIdleStatus = () => isUserIdle;